import { ToolInfo } from "@/contexts/ToolsContext";

const CDN_URL = "https://pfpmakerai-v3.sfo3.cdn.digitaloceanspaces.com";

const TOOL_DASHBOARD_IMAGE_CONFIG: Record<string, string[]> = {
  "ai-headshots": [
    `${CDN_URL}/ai-headshots/slider/slider-4-1.png`,
    `${CDN_URL}/ai-headshots/slider/slider-1.png`,
    `${CDN_URL}/ai-headshots/slider/slider-2.png`,
    `${CDN_URL}/ai-headshots/slider/slider-3.png`,
    `${CDN_URL}/ai-headshots/slider/slider-5.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_42.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_7.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_37.png`,
  ],
  "ai-avatars": [
    `${CDN_URL}/ai-avatars/F/192.png`,
    `${CDN_URL}/ai-avatars/F/201.png`,
    `${CDN_URL}/ai-avatars/F/202.png`,
    `${CDN_URL}/ai-avatars/F/203.png`,
    `${CDN_URL}/ai-avatars/F/187.png`,
    `${CDN_URL}/ai-avatars/F/188.png`,
    `${CDN_URL}/ai-avatars/F/189.png`,
    `${CDN_URL}/ai-avatars/F/190.png`,
  ],
  "basic-headshots": [
    "/assets/images/slider/2.png",
    "/assets/images/slider/3.png",
    "/assets/images/slider/4.png",
    "/assets/images/slider/5.png",
    "/assets/images/slider/6.png",
    "/assets/images/slider/7.png",
    "/assets/images/slider/8.png",
    "/assets/images/slider/9.png",
  ],
  "ai-makeup": [
    `${CDN_URL}/ai-makeup/1.png`,
    `${CDN_URL}/ai-makeup/56.png`,
    `${CDN_URL}/ai-makeup/2.png`,
    `${CDN_URL}/ai-makeup/3.png`,
    `${CDN_URL}/ai-makeup/4.png`,
    `${CDN_URL}/ai-makeup/5.png`,
    `${CDN_URL}/ai-makeup/6.png`,
    `${CDN_URL}/ai-makeup/7.png`,
  ],
  "change-clothes": [
    `${CDN_URL}/ai-headshots/F/outfit_F_42.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_7.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_37.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_14.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_46.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_17.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_22.png`,
    `${CDN_URL}/ai-headshots/F/outfit_F_30.png`,
  ],
  "ai-background": [
    `${CDN_URL}/ai-headshots/BG/bg_36.png`,
    `${CDN_URL}/ai-headshots/BG/bg_45.png`,
    `${CDN_URL}/ai-headshots/BG/bg_49.png`,
    `${CDN_URL}/ai-headshots/BG/bg_50.png`,
    `${CDN_URL}/ai-headshots/BG/bg_48.png`,
    `${CDN_URL}/ai-headshots/BG/bg_41.png`,
    `${CDN_URL}/ai-headshots/BG/bg_38.png`,
    `${CDN_URL}/ai-headshots/BG/bg_40.png`,
  ],
  "cartoonizer": [
    `${CDN_URL}/cartoonizer/F/simpsons.png`,
    `${CDN_URL}/cartoonizer/F/south_park.png`,
    `${CDN_URL}/cartoonizer/F/rick_morty.png`,
    `${CDN_URL}/cartoonizer/F/family_guy.png`,
    `${CDN_URL}/cartoonizer/F/disney.png`,
    `${CDN_URL}/cartoonizer/F/disney_classic.png`,
    `${CDN_URL}/cartoonizer/F/marvel.png`,
    `${CDN_URL}/cartoonizer/F/pixar.png`,
  ],
  "anime-styling": [
    `${CDN_URL}/anime/shonen.png`,
    `${CDN_URL}/anime/shojo.png`,
    `${CDN_URL}/anime/chibi.png`,
    `${CDN_URL}/anime/cyberpunk.png`,
  ],
  "add-accessories": [
    `${CDN_URL}/accessories/F/stud_earrings.png`,
    `${CDN_URL}/accessories/F/hoop_earrings.png`,
    `${CDN_URL}/accessories/F/drop_earrings.png`,
    `${CDN_URL}/accessories/F/headband.png`,
    `${CDN_URL}/accessories/F/hair_clip.png`,
    `${CDN_URL}/accessories/F/scrunchie.png`,
    `${CDN_URL}/accessories/F/glasses.png`,
    `${CDN_URL}/accessories/F/necklace.png`,
  ],
  "change-hair": [
    `${CDN_URL}/hairstyle/F/straight_pixie_f.png`,
    `${CDN_URL}/hairstyle/F/bangs.png`,
    `${CDN_URL}/hairstyle/F/straight_bob_f.png`,
    `${CDN_URL}/hairstyle/F/curly_bob_f.png`,
    `${CDN_URL}/hairstyle/F/curly_bun_f.png`,
    `${CDN_URL}/hairstyle/F/wavy_ponytail_f.png`,
    `${CDN_URL}/hairstyle/F/straight_bun_f.png`,
    `${CDN_URL}/hairstyle/F/wavy_long_f.png`,
  ],
  "ai-branding": [
    `${CDN_URL}/branding/F/1.png`,
    `${CDN_URL}/branding/F/2.png`,
    `${CDN_URL}/branding/F/3.png`,
    `${CDN_URL}/branding/F/4.png`,
    `${CDN_URL}/branding/F/6.png`,
    `${CDN_URL}/branding/F/7.png`,
    `${CDN_URL}/branding/F/8.png`,
    `${CDN_URL}/branding/F/9.png`,
  ],
  "photo-filters": [
    `${CDN_URL}/photo-filters/clarendon.png`,
    `${CDN_URL}/photo-filters/juno.png`,
    `${CDN_URL}/photo-filters/lark.png`,
    `${CDN_URL}/photo-filters/ludwig.png`,
    `${CDN_URL}/photo-filters/valencia.png`,
    `${CDN_URL}/photo-filters/gingham.png`,
    `${CDN_URL}/photo-filters/lofi.png`,
    `${CDN_URL}/photo-filters/mayfair.png`,
  ],
};

const TOOL_TOTAL_STYLES: Record<string, number> = {
  "ai-headshots": 515,
  "ai-avatars": 197,
  "basic-headshots": 45,
  "ai-makeup": 55,
  "change-clothes": 387,
  "ai-background": 94,
  "cartoonizer": 20,
  "anime-styling": 10,
  "add-accessories": 28,
  "change-hair": 84,
  "ai-branding": 0,
  "add-logo-watermark": 13,
  "photo-filters": 30,
};

export function getDashboardToolImages(tool: ToolInfo): string[] {
  const configured = TOOL_DASHBOARD_IMAGE_CONFIG[tool.id] ?? [];
  const base = [tool.imageUrl, ...configured].filter(Boolean);
  const uniq = Array.from(new Set(base.filter(Boolean)));

  if (uniq.length > 0) return uniq.slice(0, 8);
  return ["/assets/images/tools/blank.png"];
}

export function getTotalStyleCount(toolId: string): number {
  return TOOL_TOTAL_STYLES[toolId] ?? 0;
}
